export class ResetPassword {
    email!: string;
    password!: string;
    recoveryCode!: string;
}